'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_ListGroupings$() {
}
export { $c_Lpresto_ListGroupings$ as $c_Lpresto_ListGroupings$ };
$p = $c_Lpresto_ListGroupings$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListGroupings$;
/** @constructor */
function $h_Lpresto_ListGroupings$() {
}
export { $h_Lpresto_ListGroupings$ as $h_Lpresto_ListGroupings$ };
$h_Lpresto_ListGroupings$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1445104462);
});
$p.l = (function() {
  return "ListGroupings";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "ListGroupings";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dw = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().qe);
});
var $d_Lpresto_ListGroupings$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListGroupings$, "presto.ListGroupings$", ({
  KW: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_ListGroupings$ as $d_Lpresto_ListGroupings$ };
var $n_Lpresto_ListGroupings$;
function $m_Lpresto_ListGroupings$() {
  if ((!$n_Lpresto_ListGroupings$)) {
    $n_Lpresto_ListGroupings$ = new $c_Lpresto_ListGroupings$();
  }
  return $n_Lpresto_ListGroupings$;
}
export { $m_Lpresto_ListGroupings$ as $m_Lpresto_ListGroupings$ };
//# sourceMappingURL=presto.-List-Groupings$.js.map
